var map = {
	"./module/auth/auth.module": [
		"./src/app/module/auth/auth.module.ts"
	],
	"./module/dashboard/dashboard.module": [
		"./src/app/module/dashboard/dashboard.module.ts",
		"module-dashboard-dashboard-module"
	],
	"./module/profile/profile.module": [
		"./src/app/module/profile/profile.module.ts"
	],
	"./module/receipt/receipt.module": [
		"./src/app/module/receipt/receipt.module.ts",
		"module-receipt-receipt-module"
	],
	"./module/receiver-message/receiver-message.module": [
		"./src/app/module/receiver-message/receiver-message.module.ts",
		"module-receiver-message-receiver-message-module"
	],
	"./module/reportes/reportes.module": [
		"./src/app/module/reportes/reportes.module.ts",
		"module-reportes-reportes-module"
	],
	"./module/sendReceipts/sendReceipts.module": [
		"./src/app/module/sendReceipts/sendReceipts.module.ts",
		"module-sendReceipts-sendReceipts-module"
	],
	"./module/transactions/transactions.module": [
		"./src/app/module/transactions/transactions.module.ts",
		"module-transactions-transactions-module"
	],
	"./module/usuarioSecundario/usuarioSecundario.module": [
		"./src/app/module/usuarioSecundario/usuarioSecundario.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;